<template>
  <div class="uk-form-row">
    <div class="uk-form-label-flex">
      <label
        v-if="label"
        :for="labelFor"
        class=""
      >{{ label }}</label>
      <form-error
        v-if="errorMessage"
        :message="errorMessage"
        class="uk-margin-small-left"
        style="margin-right: auto"
      />
      <slot name="label" />
    </div>

    <div class="uk-form-controls">
      <slot name="above" />
      <slot />
      <slot name="below" />
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import formError from './form-error.vue';
  @Component({
    components: {
      'form-error': formError,
    }
  })
  export default class FormRow extends Vue {
    @Prop({default: ''}) readonly label!: string;
    @Prop() readonly labelFor!: string;
    @Prop() readonly errorMessage!: string;
  }
</script>

<style scoped>

</style>
